import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import middlewarePipeline from '@/_core/router/middlewarePipeline'
import { publicPath } from '../../vue.config'

import authToken from './middleware/authToken'
import tryAuthenticate from './middleware/tryAuthenticate'
import isAuthenticated from './middleware/isAuthenticated'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Home')
  },
  {
    path: '/catalog/',
    name: 'Catalog',
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Catalog')
  },
  {
    path: '/books/:id',
    name: 'Book',
    props: route => ({ bookId: Number(route.params.id) }),
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Book')
  },
  {
    path: '/lesson/:id',
    name: 'Lesson',
    props: route => ({ lessonId: Number(route.params.id) }),
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Lesson'),
    meta: {
      middleware: [isAuthenticated]
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "core" */ '@/components/PersonalAccount/PersonalAccountViews/Profile/Profile'),
    meta: {
      middleware: [isAuthenticated]
    }
  },
  {
    path: '/books-progress',
    name: 'BooksProgress',
    component: () => import(/* webpackChunkName: "core" */ '@/components/PersonalAccount/PersonalAccountViews/BooksProgress/BooksProgress'),
    meta: {
      middleware: [isAuthenticated]
    }
  },
  {
    path: '/vpr-progress',
    name: 'VprProgress',
    component: () => import(/* webpackChunkName: "core" */ '@/components/PersonalAccount/PersonalAccountViews/VprProgress/VprProgress'),
    meta: {
      middleware: [isAuthenticated]
    }
  },
  {
    path: '/vpr',
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Vpr'),
    redirect: { name: 'VprProgress' },
    children: [
      {
        path: ':id',
        name: 'VprContents',
        props: route => ({ vprId: Number(route.params.id) }),
        component: () => import(/* webpackChunkName: "core" */ '@/components/Vpr/VprContents/VprContents'),
        children: [
          {
            path: 'startwork',
            name: 'VprStartWork',
            component: () => import(/* webpackChunkName: "core" */ '@/components/Vpr/VprStartwork/VprStartwork'),
            meta: { middleware: [isAuthenticated] }
          },
          {
            path: 'howto',
            name: 'VprHowto',
            component: () => import(/* webpackChunkName: "core" */ '@/components/Vpr/VprHowto/VprHowto'),
            meta: { middleware: [isAuthenticated] }
          },
          {
            path: 'controlworks/:subthemeId',
            name: 'VprControlworks',
            props: route => ({ subthemeId: Number(route.params.subthemeId) }),
            component: () => import(/* webpackChunkName: "core" */ '@/components/Vpr/VprControlworks/VprControlworks'),
            meta: { middleware: [isAuthenticated] },
            children: [
              {
                path: 'tasks/:taskId',
                name: 'VprTask',
                props: route => ({ taskId: Number(route.params.taskId) }),
                component: () => import(/* webpackChunkName: "core" */ '@/components/Vpr/VprTask/VprTaskPlayer')
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/basket',
    name: 'Basket',
    component: () => import(/* webpackChunkName: "core" */ '@/pages/Basket')
  },
  {
    path: '/:notFound(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "core" */ '@/pages/404')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  base: publicPath
})

router.beforeEach((to, from, next) => {
  const sharedMiddleware = [
    authToken,
    tryAuthenticate
  ]

  let middleware = sharedMiddleware

  if (to.meta.middleware) middleware = middleware.concat(Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware])

  if (!middleware.length) return next()

  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    nextMiddleware: middlewarePipeline(context, middleware, 1)
  })
})

export default router
